import { ApiService } from '../../../services/api_service';
import btnSty from '../../../core/elements/buttons.less';
import { DataService } from '../../../services/data_service';
import { formStyle, WForm, WFormConfig, WFormData } from '../../../core/forms/WFormFramework';
import DialogWrapper2 from '../../../core/dialog/dialog_wrapper_v2';
import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { StructureTool } from '../../../core/forms/helpers/structure_tool';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';
import { WHelpIcon } from '../../../core/elements/WHelpIcon';
import * as Moment from 'moment';

interface MailSenderProps extends React.ClassAttributes<any> {
    data: any;
    mailRow: any;
}

interface MailSenderState {
    data: Array<any>;
    formConfig: WFormConfig;
    showSelectEmpfaenger: boolean;
    empfaenger: any;
    empfaengerText: string;
    formData: WFormData;
    isAllChecked: boolean;
    showDataBerater: boolean;
    showDataStandard: boolean;
    showDataTest: boolean;
    showDataBereich: string;
}

export class MailSender extends React.Component<MailSenderProps, MailSenderState> {

    constructor(props: any) {
        super(props);
        const { mailRow } = props;
        const formData = new WFormData();
        formData.setValue('titel', mailRow.titel);
        formData.setValue('inhalt', mailRow.inhalt);
        this.state = {
            data: null,
            formConfig: null,
            showSelectEmpfaenger: false,
            empfaenger: {},
            empfaengerText: null,
            formData,
            isAllChecked: false,
            showDataBerater: undefined,
            showDataStandard: true,
            showDataTest: undefined,
            showDataBereich: 'Alle'
        };
        this.getData = this.getData.bind(this);
        this.onRowSelect = this.onRowSelect.bind(this);
        this.preFilter = this.preFilter.bind(this);
        this.sendMail = this.sendMail.bind(this);
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(DataService) private dataService: DataService;

    componentDidMount(): void {
        this.getFormConfig();
        this.getKonfiguration(this.getData);
    }

    getCustomColumns(): Array<any> {
        return ([
            {
                accessor: 'name',
                Header: 'Unternehmen / Berater',
                id: 'name'
            },
            {
                accessor: 'bereich',
                Header: 'Bereich',
                id: 'bereich',
                filterable: false
            },
            {
                accessor: 'mail',
                Header: 'E-Mail',
                id: 'mail'
            },
            {
                accessor: 'art',
                Header: 'Art',
                id: 'art',
                filterable: false
            },
            {
                accessor: 'datum_bearbeitung',
                Header: 'Letzte Bearbeitung',
                id: 'datum_bearbeitung',
                filterable: false,
                sortMethod: (a: any, b: any) => {
                    const arrA = (typeof a === 'string' ? a : '').split('.');
                    const arrB = (typeof b === 'string' ? b : '').split('.');
                    const numA = (arrA[2] || '') + (arrA[1] || '') + (arrA[0] || '');
                    const numB = (arrB[2] || '') + (arrB[1] || '') + (arrB[0] || '');
                    return (parseInt(numA, 10) || 0) - (parseInt(numB, 10) || 0);
                }
            }
        ]);
    }

    getData(konfiguration: Array<any>): void {
        const data: any = this.props.data || {};
        const empfaenger: Array<any> = [];
        let tid: number = 0;
        (data[IDs.ENT_REGISTRIERUNG] || [])
            .filter((r: any) => r.newsletter_abo === 1)
            .forEach((registrierung: any) => {
                const test: boolean = +registrierung.test_registrierung === 1;
                empfaenger.push({
                    tid: ++tid,
                    name: registrierung.unternehmen,
                    bereich: registrierung.bereich_key,
                    mail: registrierung.mail,
                    art: test ? 'Test' : 'Regulär',
                    datum_bearbeitung: registrierung.datum_bearbeitung > 0 ? Moment.unix(registrierung.datum_bearbeitung).format('DD.MM.YYYY') : '',
                    berater: false,
                    test
                });
            });
        (data[IDs.ENT_BERATER] || []).forEach((berater: any) => {
            empfaenger.push({
                tid: ++tid,
                name: berater.name,
                bereich: berater.bereich_key,
                mail: berater.mail,
                art: 'Berater',
                datum_bearbeitung: berater.datum_angelegt > 0 ? Moment.unix(berater.datum_angelegt).format('DD.MM.YYYY') : '',
                berater: true,
                test: false
            });
        });
        empfaenger.sort((a: any, b: any) => {
            if (a.name > b.name) {
                return 1;
            }
            if (a.name < b.name) {
                return -1;
            }
            return 0;
        });
        this.setState({ data: empfaenger });
    }

    getFormConfig(): void {
        const struct_tool = new StructureTool(IDs.MOD_ETOOL_ADMIN);
        struct_tool.generateFormConfig(IDs.ENT_MAIL, (formConfig: WFormConfig) => {
            this.setState({ formConfig });
        });
    }

    getKonfiguration(callback: (data: any) => void): void {
        this.dataService.loadData(IDs.ENT_KONFIGURATION, {}, { fieldList: 'etool_test, mandant' }, (data: any) => {
            if (typeof callback === 'function') {
                callback(data[IDs.ENT_KONFIGURATION] || []);
            }
        }, IDs.MOD_ETOOL);
    }

    getHeaderElements(): Array<JSX.Element> {
        const { data } = this.props;
        const bereiche: Array<any> = [... (data['registrierung_bundle'].bereich_key || [])];
        bereiche.unshift({ name: 'Alle' });

        const style: React.CSSProperties = {
            cursor: 'pointer', display: 'flex', alignItems: 'center', height: 28, marginTop: 2, fontSize: 12, padding: '0 3px',
            backgroundColor: 'rgb(188, 202, 227)', marginRight: 2
        };

        return [
            <label style={style}>
                <input
                    type='checkbox'
                    checked={this.state.showDataStandard}
                    onChange={(event: any) => this.setState({ showDataStandard: event.target.checked })}
                />
                Reguläre Datensätze
            </label>,
            <label style={style}>
                <input
                    type='checkbox'
                    checked={this.state.showDataTest}
                    onChange={(event: any) => this.setState({ showDataTest: event.target.checked })}
                />
                Testdatensätze
            </label>,
            <label style={style}>
                <input
                    type='checkbox'
                    checked={this.state.showDataBerater}
                    onChange={(event: any) => this.setState({ showDataBerater: event.target.checked })}
                />
                Berater
            </label>,
            <label style={style}>
                Bereich:
                <select
                    style={{ marginLeft: 5 }}
                    value={this.state.showDataBereich}
                    onChange={(event: any) => this.setState({ showDataBereich: event.target.value })}
                >
                    {bereiche.map((b: any) => <option value={b.name}>{b.name}</option>)}
                </select>
            </label>
        ];
    }

    preFilter(data: Array<any>): Array<any> {
        const { showDataStandard, showDataBerater, showDataTest, showDataBereich } = this.state;
        return showDataStandard || showDataBerater || showDataTest || showDataBereich ? data.filter((item: any) =>
            ((showDataStandard && !item.test && !item.berater) || (showDataBerater && item.berater) || (showDataTest && item.test))
            && (showDataBereich === 'Alle' || item.bereich === showDataBereich)
        ) : [];
    }

    render(): JSX.Element {
        const { formConfig, formData } = this.state;

        return (
            <div>
                {this.renderEmpfaenger()}
                <WForm
                    entity={IDs.ENT_MAIL}
                    titel={'SendMail'}
                    layout={'flowV2'}
                    layout2={'noneAutoSave'}
                    config={formConfig}
                    dataIn={formData}
                    showFieldsHelp={true}
                    hideCancel={true}
                    hideSave={true}
                    hideTitel={true}
                    onFormSave={() => { }}
                    onFormCancel={() => { }}
                    onFormChange={(data: WFormData) => this.setState({ formData: data })}
                />
                <button
                    style={{ float: 'right', margin: 15 }}
                    className={btnSty.textButton}
                    onClick={this.sendMail}
                >
                    Versenden
                </button>
                {this.renderSelectEmpfaenger()}
            </div>
        );
    }

    renderEmpfaenger(): JSX.Element {
        const { empfaengerText } = this.state;

        return (
            <div className={formStyle.fieldBox} style={{ padding: 3, marginTop: 10 }}>
                <div className={formStyle.label} style={{ fontSize: 14.6, display: 'flex', justifyContent: 'space-between' }}>
                    <div>Empänger</div>
                    <WHelpIcon
                        data={this.props.data}
                        styleDivProps={{ marginLeft: 0, marginRight: 10 }}
                        styleProps={{
                            width: 18, height: 18, borderRadius: 10, backgroundColor: '#b9cde5', verticalAlign: 'top', margin: 0
                        }}
                        label='Info "Empänger"'
                        helpKey={`${IDs.MOD_ETOOL_ADMIN}_${IDs.ENT_MAIL}_Empänger`}
                        type='info'
                        editBar={true}
                    />
                </div>
                <div className={formStyle.input}>
                    <textarea
                        value={empfaengerText}
                        readOnly={true}
                        style={{
                            fontSize: 14, width: 'calc(100% - 13px)', height: 32, resize: 'vertical', maxHeight: 200, cursor: 'pointer'
                        }}
                        onClick={() => this.setState({ showSelectEmpfaenger: true })}
                    />
                </div>
            </div>
        );
    }

    renderSelectEmpfaenger(): JSX.Element {
        if (this.state.showSelectEmpfaenger && this.state.data) {
            const { empfaenger } = this.state;
            const checkedRows: any = {};
            Object.keys(empfaenger).forEach((i: string) => checkedRows[i] = true);

            return (
                <DialogWrapper2
                    title={'Empfänger auswählen'}
                    onAfterClose={() => this.setState({ showSelectEmpfaenger: false })}
                >
                    <WFormsTableWrapper
                        entity={IDs.ENT_REGISTRIERUNG}
                        module={IDs.MOD_ETOOL_ADMIN}
                        data={this.state.data}
                        preFilterFunction={this.preFilter}
                        customClass='Custom-ETA'
                        formLayout='flowV2'
                        hiddenColumns={['_ALL']}
                        customColumns={this.getCustomColumns()}
                        columnWidths={[250, 100, 300, 100]}
                        externalHeaderElements={this.getHeaderElements()}
                        enableRowCheckbox={true}
                        tablePageSize={15}
                        onRowSelect={this.onRowSelect}
                        allCheckboxChecked={this.state.isAllChecked}
                        checkedRows={checkedRows}
                        showColumnsHelp={false}
                        hideFilterReset={true}
                        hideExport={true}
                    />
                    <div>
                        <button
                            style={{ padding: 5, float: 'right', margin: '10px 0' }}
                            onClick={() => {
                                const empfaengerText = Object.keys(this.state.empfaenger)
                                    .map((i: string) => empfaenger[i].mail).join('; ');
                                this.setState({ empfaengerText, showSelectEmpfaenger: false });
                            }}
                        >
                            Übernehmen und Schließen
                        </button>
                    </div>
                </DialogWrapper2>
            );
        }
        return null;
    }

    onRowSelect(row: any, selected: boolean, checkedRows: any): void {
        const isAllChecked = row.tid === 'all' && selected === true;
        let empfaenger: any = this.state.empfaenger || {};

        if (row.tid === 'all') {
            empfaenger = {};

            (this.state.data || []).forEach((item: any) => {
                if (checkedRows[item.tid]) {
                    empfaenger[item.tid] = item;
                }
            });
        } else {
            if (selected) {
                empfaenger[row.tid] = row;
            } else {
                delete empfaenger[row.tid];
            }
        }
        this.setState({ empfaenger, isAllChecked });
    }

    sendMail(): void {
        const { empfaenger, formData } = this.state;
        const values = formData.getAllValues();
        const empf = Object.keys(empfaenger).map((i: string) => empfaenger[i].mail);
        // console.log(empf, values);
        if (empf.length === 0) {
            alert('Wählen Sie bitte Empfänger aus!');
        } else {
            this.apiService.call('sendMail', {
                // emailTo: empf, // ohne emailTo bekommen Empänger die Mail als BCC
                bcc: empf,
                subject: values.titel,
                text: values.inhalt,
                isHtml: true,
                filename: values.anhang_archiv_filename || null,
                content: values.anhang_archiv_rawdata || null
            }, (data: string, succ: boolean) => {
                // console.log(data, succ);
                if (succ) {
                    alert('E-Mail wurde erfolgreich versendet.');
                }
            }, IDs.MOD_ETOOL_ADMIN);
        }
    }
}
